import Dialog from '@rio-cloud/rio-uikit/Dialog';
import IframeResizer from 'iframe-resizer-react';

import { useAppDispatch, useAppSelector } from '@/configuration/setup/hooks';
import { closeMfeDialog, getMfeDialogIsOpen, getMfeDialogTitle, getMfeDialogUrl } from '@/features/microfrontends/slice/mfeDialogSlice';
import { prepareUrl } from './microfrontendsConfig';

const MfeDialog = () => {
    const dispatch = useAppDispatch();
    const isOpen = useAppSelector(getMfeDialogIsOpen);
    const title = useAppSelector(getMfeDialogTitle);
    const url = useAppSelector(getMfeDialogUrl);

    const handleClose = () => dispatch(closeMfeDialog());

    return (
        <Dialog
            show={isOpen}
            onClose={handleClose}
            title={title}
            showCloseButton
            body={
                url && (
                    <IframeResizer
                        src={prepareUrl(url)}
                        checkOrigin={false}
                        heightCalculationMethod="lowestElement"
                        style={{
                            width: '1px',
                            minWidth: '100%',
                            border: '0',
                        }}
                    />
                )
            }
        />
    );
};

export default MfeDialog;
